import { AutoSubmit } from 'components/Forms/AutoSubmit';
import { Formik, Form, FormikConfig } from 'formik';
import { OpinionFilterSortSelectField } from './OpinionFilterSortSelectField';

export type OpinionFilterVariables = {
  sort: 'createdAt' | 'likesCount';
}

export type OpinionFilterProps = {
  onSubmit: FormikConfig<OpinionFilterVariables>['onSubmit'];
}

const INITIAL_VALUES: OpinionFilterVariables = { sort: 'createdAt' };

export const OpinionFilter = ({ onSubmit }: OpinionFilterProps) => {
  return (
    <Formik<OpinionFilterVariables> initialValues={INITIAL_VALUES} onSubmit={onSubmit}>
      <Form>
        <OpinionFilterSortSelectField />
        <AutoSubmit />
      </Form>
    </Formik>
  );
};
